import type {Dominio} from "services-comun-tiempo/modules/portal";
import {IConf} from "../utiles/config";

export interface IControlador {
    cfg: IConf;
    dominio: Dominio;
    element: Element;
    selector: string;
}

export abstract class Controlador<T extends IControlador = IControlador> {
    /* INSTANCE */
    public ejecutando: boolean;
    public primeraEjecucion: boolean;

    protected get element(): Element { return this.ctx.element; }

    protected constructor (protected ctx: T) {
        this.ejecutando = false;
        this.primeraEjecucion = true;
    }

    public async afterRun(): Promise<void> {
        this.ejecutando = false;
        this.primeraEjecucion = false;
    }
    public async beforeRun(): Promise<void> {
        this.ejecutando = true;
    }
    public async errorRun(): Promise<void> {
        this.ejecutando = false;
    }

    public abstract run(): Promise<void>;
}
